import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// 使用vue-axios代替axios
Vue.use(VueAxios, axios)
